import {BASE_URL} from "app/config/env";

const prefix = `${BASE_URL}/panel`;


export const taskFieldCodes = {
  'app.taskFieldCodes': `${prefix}/task-field-codes/`,
}
